<template>
  <div class="container">
    <Transition name="fade">
      <div v-if="showModal" class="font-backdrop" @click="backdropOnClick" />
    </Transition>
    <Transition name="slide-down">
      <div v-if="showModal" class="font-modal-container">
        <div class="font-modal-title">
          {{ $t('ARTICLE.FONT_SIZE_LEVEL') }}
        </div>
        <div class="font-modal-list">
          <div :class="{current: fontSizeLevel === 'SMALL'}" class="font-modal-item small" @click="sizeItemOnClick('SMALL')">
            A
          </div>
          <div :class="{current: fontSizeLevel === 'MEDIUM'}" class="font-modal-item medium" @click="sizeItemOnClick('MEDIUM')">
            A
          </div>
          <div :class="{current: fontSizeLevel === 'LARGE'}" class="font-modal-item large" @click="sizeItemOnClick('LARGE')">
            A
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: 'ArticleFontSizeModal',
  components: {},
  directives: {},
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    fontSizeLevel() {
      return this.$store.state.article.fontSizeLevel
    }
  },
  watch: {},
  created() {},
  mounted() {
  },
  updated() {},
  methods: {
    backdropOnClick() {
      this.$emit('closeFontSizeModal')
    },
    sizeItemOnClick(newVale) {
      this.$store.commit('UPDATE_FONTSIZE_LEVEL', newVale)
      this.$emit('closeFontSizeModal') // auto close
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.font-backdrop {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  transition: opacity 300ms ease-in-out;
  overflow-y: hidden;
}
.font-modal {

  &-container {
    z-index: 101;
    position: fixed;
    left: calc((100% - 380px) / 2);
    top: 120px;
    height: 220px;
    width: 380px;
    margin: 0 auto;
    border-radius: 8px;
    background-color:white;
    box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.27);
    overflow-x: hidden;
    overflow-y: hidden;
  }
  &-title {
    margin-top: 36px;
    margin-left: 69px;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.63;
    color: $grey-9b;
  }
  &-list {
    margin-top: 16px;
    margin-left: 69px;
  }
  &-item {
    // display: inline-block;
    // vertical-align: top;
    float: left;
    width: 70px;
    height: 70px;
    margin-right: 16px;
    margin-bottom: 16px;
    font-weight: 500;
    line-height: 70px;
    text-align: center;
    border-radius: 4px;
    background-color: $grey-f3;
    color: $grey-50;
    cursor: pointer;
  }
  &-item:last-child {
    margin-right: 0;
  }
  &-item.small {
    font-size: 14px;
  }
  &-item.medium {
    font-size: 24px;
  }
  &-item.large {
    font-size: 36px;
  }
  &-item.current {
    color: $theme-red;
  }
}
@media only screen and (min-width: 1440px) {
  // As same as default
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  // As same as default
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  // As same as default
}

@media only screen and (max-width: 767.98px) {
  //  As same as default
}

@media only screen and (max-width: 448.98px) {
  // special case
  .font-modal {
    &-container {
      left: 24px;
      width: calc(100% - (24px * 2));
    }
    &-title {
      margin-top: 24px;
      margin-left: 24px;
    }
    &-list {
      height: 70px;
      // margin-top: 16px;
      margin-left: 0;
      text-align: center;
    }
    &-item {
      float: initial; // reset
      display: inline-block;
      vertical-align: top;
      margin-right: 8px;
      margin-bottom: 8px;
    }
  }
}
</style>
